import { observer } from 'mobx-react-lite';
import { Button, Card, Grid, Header, Image, Tab } from 'semantic-ui-react';
import { Profile } from '../../app/models/Profile';
import { useStore } from '../../app/stores/store';
import { useState } from 'react';
import PhotoUploadWidget from '../../app/common/imageUpload/PhotoUploadWidget';
import { useTranslation } from 'react-i18next'; // Add this import for i18n

interface Props{
    profile:Profile;
  }

export default observer(function ProfilePhotos({profile}:Props) {

    const{profileStore:{isCurrentUser, uploadPhoto, uploading}} = useStore();
    const[addPhotoMode,setAddPhotoMode] = useState(false);
    const { t } = useTranslation(); // Initialize translation hook

    function handlePhotoUpload(file: File)
    {
        uploadPhoto(file).then(()=> setAddPhotoMode(false));
    }

  return (
    <Tab.Pane>
      <Grid>
        <Grid.Column width={16}>
            <Header floated='left' icon='image' content={t('profilePhotos.photos')} />
            {isCurrentUser && (
            <Button
                floated='right' 
                basic
                content={addPhotoMode ? t('profilePhotos.cancel') : t('profilePhotos.addPhoto')}
                onClick={() => setAddPhotoMode(!addPhotoMode)}
            />
            )}
        </Grid.Column>
        <Grid.Column width={16}>
            {addPhotoMode ? (
            <PhotoUploadWidget uploadPhoto={handlePhotoUpload} loading={uploading}/>
            ) : (
             <Image src={profile.image} />
            )}
        </Grid.Column>
        </Grid>

    </Tab.Pane>
  )
})